import axiosClient, { ResponseSuccess, ResponseSuccessTotal } from "../axiosClient";

export interface IProfession {
  id: number
  title: string
  status: number
}
export const getListProfession = async (search?: string) => {
  const path = "profession/listProfession"
  const params = { search }
  const result: ResponseSuccessTotal<IProfession[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};
